
import { Facet } from '../models/Facet';
import { implementOperation, IOperationActionCreator } from '../store/actions/implementOperation';

export const createFolderOperation = new Facet<{
  folders: {
    [folderName: string]: {
      progressItemKey?: string;
    };
  };
}>('createFolder');

export const createFolder: IOperationActionCreator<typeof createFolderOperation.type> = implementOperation({
  operationTypeFacet: createFolderOperation
});
